export default "__VITE_ASSET__fb8c69d9__"